import React, { useEffect, useState } from "react";
import Header from "../Components/header";
import { GraphQLClient } from "graphql-request";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const getAbbonamenti = async () => {
  const client = new GraphQLClient(
    "https://api-eu-central-1-shared-euc1-02.hygraph.com/v2/clweq2m6a000001w67aqzeh7x/master"
  );

  const query = `query MyQuery {
    abbonamentis {
      titolo
      id
      slugAbbonamento
      copertina {
        url
      }
      prezzo
    }
  }
  
  
  `;

  try {
    const data = await client.request(query);
    console.log(data.abbonamentis);
    return data.abbonamentis;
  } catch (error) {
    console.error("Error fetching issues:", error);
    throw error;
  }
};

const Abbonamenti = () => {
  const [abbonamenti, setAbbonamenti] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchAbbonamenti = async () => {
      try {
        const abbonamentiData = await getAbbonamenti();
        console.log(abbonamentiData);
        await setAbbonamenti(abbonamentiData);
        const imagePromises = abbonamentiData.map((abbonamento) => {
          return new Promise((resolve) => {
            const img = new Image();
            img.src = abbonamento.copertina.url;
            img.onload = resolve;
            img.onerror = resolve;
          });
        });

        await Promise.all(imagePromises);
        await setIsLoading(false);
      } catch (error) {
        console.error("Error fetching page:", error);
      }
    };
    fetchAbbonamenti();
  }, []);

  if (isLoading) {
    return (
      <div>
        <Header />
        <h1 className="mt-10 text-4xl font-bold">Abbonamenti</h1>
        <div className="mt-10 grid sm:grid-cols-3">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index}>
              <Skeleton width={"50%"} height={"250px"} />
              <Skeleton width={"50%"} height={10} className="mt-10 mb-5" />
              <Skeleton width={"10%"} height={10} className="" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <Helmet>
        <title>Modellistica International- Abbonamenti</title>
        <meta
          name="description"
          content="Scopri il mondo dell'aeromodellismo e modellismo con Modellistica International, la rivista dedicata agli appassionati."
        />
        <meta
          name="keywords"
          content="modellistica, aeromodelli, modellistica international, modellismo, abbonamenti modellismo, rivista modellistica abbonamento"
        />
        <link
          rel="canonical"
          href={`https://www.riccardobenincasa.com${location.pathname}`}
        />
      </Helmet>
      <h1 className="mt-10 text-4xl font-bold">Abbonamenti</h1>
      <div className="mt-10 grid sm:grid-cols-3">
        {isLoading ? (
          <Skeleton></Skeleton>
        ) : (
          abbonamenti.map((abbonamento) => (
            <Link
              to={`/abbonamenti/${abbonamento.slugAbbonamento}`}
              key={abbonamento.id}
            >
              <div className="flex flex-col p-4 rounded items-center">
                <img
                  src={abbonamento.copertina.url}
                  alt={abbonamento.copertina.filename}
                  className="w-full h-auto mx-auto max-w-full shadow-md hover:scale-110 transition duration-500 ease-in-out"
                  style={{
                    maxHeight: "250px",
                    maxWidth: "180px",
                    minHeight: "250px",
                    minWidth: "90px",
                  }}
                />
                <p className=" font-bold mt-4">{abbonamento.titolo}</p>
                <p className="font-bold text-gray-600 mt-2">
                  € {abbonamento.prezzo}
                </p>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};
export default Abbonamenti;
